import { render } from "./Leaderboards.vue?vue&type=template&id=2432f5f9&scoped=true&ts=true"
import script from "./Leaderboards.vue?vue&type=script&lang=ts"
export * from "./Leaderboards.vue?vue&type=script&lang=ts"

import "./Leaderboards.vue?vue&type=style&index=0&id=2432f5f9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2432f5f9"]])

export default __exports__